function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "13.506",
  height: "13.506",
  x: "2.247",
  y: "2.247",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  rx: "2.25"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M15.753 5.999H2.247m8.065 2.588a.037.037 0 100 .074.037.037 0 000-.074m-2.626 2.251a.036.036 0 00-.036.037.037.037 0 10.036-.037m-2.626 0a.036.036 0 00-.037.038c0 .015.01.028.023.034a.037.037 0 10.013-.07m2.627 2.25a.036.036 0 00-.036.037.037.037 0 10.036-.037m-2.626 0a.036.036 0 00-.037.037.037.037 0 10.036-.037m7.879-4.502a.036.036 0 00-.036.037.037.037 0 00.063.026.037.037 0 00-.027-.063"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M10.313 8.588a.037.037 0 100 .074.037.037 0 000-.074m-.001 2.25a.037.037 0 100 .074.037.037 0 000-.074m2.626.002a.036.036 0 00-.036.036.037.037 0 00.063.026.037.037 0 00-.027-.063"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M10.313 10.84a.037.037 0 100 .073.037.037 0 000-.073"
}));